import { plan2plateIcons } from "../utils/iconUtils";
import { cn } from "../lib/utils";
import React from "react";

type Tone = "default" | "gold" | "muted" | "teal" | "protein";
export const Glyph = ({
  icon,
  tone = "default",
  size = 18,
  className,
}: {
  icon: keyof typeof plan2plateIcons;
  tone?: Tone;
  size?: number;
  className?: string;
}) => {
  const workarounds =
    icon == "barcode" || icon == "atHorizontalSliderDots"
      ? "[&_path]:!fill-[var(--p2p-text)] [&_path]:!stroke-[0.4px]"
      : icon == "atEmail"
        ? "[&_path]:!fill-[var(--p2p-text)]"
        : icon == "atListReceipt" || icon == "chain"
          ? "[&_path]:!fill-[var(--p2p-text)] [&_path]:!stroke-[0px]"
          : "";

  return (
    <span
      aria-hidden
      data-tone={tone === "default" ? undefined : tone}
      className={cn(
        "p2p-svg inline-flex shrink-0 items-center justify-center",
        className,
        workarounds,
      )}
      style={{ width: size, height: size }}
    >
      {plan2plateIcons[icon]}
    </span>
  );
};
export const SmallIconButton = ({
  icon,
  onClick,
  active,
  disabled,
  label,
  variant = "default",
  "data-cy": dataCy,
  className,
}: {
  icon: keyof typeof plan2plateIcons;
  onClick: () => void;
  active?: boolean;
  disabled?: boolean;
  label: string;
  variant?: "default" | "destructive";
  "data-cy"?: string;
  className?: string;
}) => {
  const size = icon == "atHorizontalSliderDots" ? 16 : 28;
  return (
    <button
      type="button"
      data-cy={dataCy}
      aria-label={label}
      title={label}
      aria-pressed={active}
      disabled={disabled}
      onClick={onClick}
      className={cn(
        "inline-flex h-9 w-9 items-center justify-center rounded-card border transition",
        "disabled:cursor-not-allowed disabled:opacity-40",
        active
          ? "border-gold bg-gold/10 text-gold"
          : variant === "destructive"
            ? "border-line bg-surface-card text-protein hover:bg-protein/10"
            : "border-line bg-surface-card text-ink-muted hover:bg-surface",
        className,
      )}
    >
      <Glyph icon={icon} size={size} />
    </button>
  );
};
